<template>
  <div>
    <currentpage :page="singleArticle['0'].title" :author="'Author: '+singleArticle['0'].author"></currentpage>
    <section>
      <b-container class="py-5">
        <b-row>
          <b-col v-html="singleArticle['0'].content"></b-col>
          <!-- <b-col md="5">
            <img :src="singleArticle['0'].image" alt="article image" class="img-fluid"/>
          </b-col> -->
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import articles from '../articles'
export default {
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    singleArticle () {
      return articles.filter(el => el.id === 1)
    }
  }
}
</script>

<style scoped>
img {
    height: 150px;
}
</style>
